<h2 mat-dialog-title>Editar perfil</h2>
<div mat-dialog-content>
    <form class="row p-1" [formGroup]="form">
        <div class="col-12">
            <div class="row text-center">
                <div class="col-12">
                    <img mat-card-image [src]="this.profileImage" class="mx-auto d-block"
                        style="width: 200px; height: 200px; margin-left: 75px; border: solid; border-radius: 100px; margin-bottom: 10px;">
                </div>
                <div class="col-12">
                    <button mat-button color="primary" class="btn-size" (click)="fileInputProfile.click()">
                        <ng-container *ngIf="!isUploadingPhoto">
                            <span *ngIf="profileImage === null">{{ 'profile.uploadProfilePicture' | translate }}</span>
                            <span *ngIf="profileImage !== null">{{ 'profile.changeProfilePicture' | translate }}</span>
                        </ng-container>
                        <ng-container *ngIf="isUploadingPhoto">
                            <div class="d-flex align-items-center justify-content-center spinner-wht">
                                <mat-spinner [diameter]="20" class="button-spinner">
                                </mat-spinner>
                            </div>
                        </ng-container>
                    </button>
                </div>
                <div class="col-12">
                    <button mat-button color="accent" class="btn-size mt-2" (click)="openCamera()">
                        <mat-icon>camera_alt</mat-icon>
                        {{ 'profile.takePhoto' | translate }}
                    </button>
                </div>

                <!-- INPUT PARA SUBIR IMAGEN -->
                <input #fileInputProfile hidden type="file" name="AttachedFile" class="file-upload"
                    accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                    (change)="upload($event.target.files)">

                <!-- CAMARA -->
                <div class="col-12 mt-3 text-center">
                    <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                        <video #videoElement hidden autoplay playsinline
                            style="width: 100%; max-width: 400px; padding-top: 10px; display: block; margin: 0 auto;">
                        </video>
                        <canvas #canvasElement hidden style="width: 100%; max-width: 400px; display: block; margin: 0 auto;">
                        </canvas>
                    </div>

                    <!-- Camera controls -->
                    <div *ngIf="isCameraActive" class="camera-controls mt-3 text-center">
                        <button mat-raised-button color="primary" class="mr-2" [disabled]="isCapturingPhoto"
                            (click)="capturePhoto()">
                            <ng-container *ngIf="!isCapturingPhoto">
                                <mat-icon>camera</mat-icon>
                                {{ 'profile.capturePhoto' | translate }}
                            </ng-container>
                            <ng-container *ngIf="isCapturingPhoto">
                                <div class="d-flex align-items-center justify-content-center">
                                    <mat-spinner [diameter]="20" class="button-spinner mr-2"></mat-spinner>
                                    <span>{{ 'profile.processingPhoto' | translate }}</span>
                                </div>
                            </ng-container>
                        </button>
                        <button mat-raised-button color="warn" class="mt-2" [disabled]="isCapturingPhoto"
                            (click)="closeCamera()">
                            <mat-icon>close</mat-icon>
                            {{ 'profile.cancel' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="row p-0" *ngIf="profile.IsIndividual">
                <div class="col-12 mb-4">
                    <mat-form-field appearance="outline" *ngIf="profile.IsIndividual">
                        <mat-label>Nombre</mat-label>
                        <input type="text" matInput formControlName="Name" required />
                        <mat-error *ngIf="form.controls['Name'].hasError('required')">
                            Campo requerido.
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-12 mb-4">
                    <mat-form-field appearance="outline" *ngIf="profile.IsIndividual">
                        <mat-label>Segundo Nombre</mat-label>
                        <input type="text" matInput formControlName="SecondName" />
                    </mat-form-field>
                </div>
                <div class="col-12 mb-4">
                    <mat-form-field appearance="outline" *ngIf="profile.IsIndividual">
                        <mat-label>Apellido</mat-label>
                        <input type="text" matInput formControlName="LastName" required />
                        <mat-error *ngIf="form.controls['LastName'].hasError('required')">
                            Campo requerido.
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-12 mb-4">
                    <mat-form-field appearance="outline" *ngIf="profile.IsIndividual">
                        <mat-label>Segundo Apellido</mat-label>
                        <input type="text" matInput formControlName="SecondLastName" />
                    </mat-form-field>
                </div>

                <div class="col-12 mb-4" *ngIf="profileTypes.length > 0">
                    <mat-form-field appearance="outline">
                        <mat-label>Tipo de Perfil</mat-label>
                        <mat-select formControlName="ProfileTypeId" required>
                            <mat-option *ngFor="let item of profileTypes" [value]="item.Id">
                                <span class="select-input">
                                    {{ item.Name }}
                                </span>
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="form.controls['ProfileTypeId'].hasError('required')">
                            Campo requerido.
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="row p-0 form-group" *ngIf="!profile.IsIndividual">
                <div class="col-12">
                    <mat-form-field appearance="outline" *ngIf="!profile.IsIndividual">
                        <mat-label>Nombre</mat-label>
                        <input type="text" matInput formControlName="Name" required />
                        <mat-error *ngIf="form.controls['Name'].hasError('required')">
                            Campo requerido.
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-12" *ngIf="profileTypes.length > 0">
                    <mat-form-field appearance="outline">
                        <mat-label>Tipo de Perfil</mat-label>
                        <mat-select formControlName="ProfileTypeId" required>
                            <mat-option *ngFor="let item of profileTypes" [value]="item.Id">
                                <span class="select-input">
                                    {{ item.Name }}
                                </span>
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="form.controls['ProfileTypeId'].hasError('required')">
                            Campo requerido.
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="col-12">
            <hr>
        </div>

        <div class="col-12">
            <app-street-postal-address-form formControlName="Address"></app-street-postal-address-form>
        </div>
    </form>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="closeDialog()">Cancelar</button>
    <button mat-flat-button color="primary" (click)="updateProfile()">Actualizar</button>
</div>